import { render, staticRenderFns } from "./customerProfileAttributes.vue?vue&type=template&id=424b4423&"
import script from "./customerProfileAttributes.vue?vue&type=script&lang=js&"
export * from "./customerProfileAttributes.vue?vue&type=script&lang=js&"
import style0 from "./customerProfileAttributes.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports